import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Controparte } from 'src/app/common/models/controparte';
import { CreazionePraticaStoreService } from '../../services/creazione-pratica-store.service';
import { Observable, Subject, combineLatest, concat } from 'rxjs';
import { Parte } from 'src/app/common/models/parte';
import { ViewChild } from '@angular/core';
import { RicercaAnagraficheFormComponent } from 'src/app/common/form/ricerca-anagrafiche-form.component';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { OperationsService } from 'src/app/core/services/operations.service';
import { SearchAnagraficheResponse } from 'src/app/common/models/dto/search-anagrafiche-response';
import { Anagrafica } from 'src/app/common/models/anagrafica';
import { AssociazioneControparteFormComponent } from './associazione-controparte-form/associazione-controparte-form.component';
import { ElaborationDocumentFilterEntity } from 'src/app/document-management/models/elaboration-doc-filter';
import { TipoPersona } from 'src/app/common/models/tipologiche/tipo-persona';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { extractParteEntityFromSearch, isControparteAssociated, isDuplicate, isParteAssociable, parteFromEntity, setTempId } from '../../utils/parti-utils';
import { filterElaborationEntity, filterElaborationEntityClean, getMockEntity, removeDuplicates as removeDuplicatesEntities } from '../../utils/wizard-utils';
import { ElaborationEntityConstants } from '../../constants/elaboration-entity-constants';
import { CreazionePraticaTipologicheService } from '../../services/creazione-pratica-tipologiche.service';
import { distinctUntilChanged, filter, skipWhile, take, takeUntil, tap } from 'rxjs/operators';
import { refreshContropartePrimaria } from '../../utils/controparti-utils';
import { Router } from '@angular/router';

@Component({
  selector: 'app-step-parti',
  templateUrl: './step-parti.component.html',
  styleUrls: ['./step-parti.component.css']
})
export class StepPartiComponent<T extends Anagrafica> implements OnInit, OnDestroy {

  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  @ViewChild('formRicercaParte') modaleRicerca: RicercaAnagraficheFormComponent<Parte>;
  requestSearchUrl = ServicePathsSettings.URL_SEARCH_PARTE;
  activeTab = 0;
  action:string;
  suggested: {isAssociable:boolean,isControparte:boolean, hasDetailsAnagrafica: boolean, anagrafica: any, categoria?: string, tipoSoggetto?: string }[] = [];
  options: {isAssociable:boolean,isControparte:boolean, hasDetailsAnagrafica: boolean, anagrafica: any }[] = [];
  controparti: Controparte[] = [];
  private tipoPersonaOptions: TipoPersona[] = [];
  private entities: ElaborationDocumentFilterEntity[];
  @Output() changeStep: EventEmitter<any> = new EventEmitter<any>()
  count = 0;

  componentDestroyed$: Subject<void> = new Subject<void>();

  constructor(
    private operations: OperationsService,
    private tipologicheService: CreazionePraticaTipologicheService,
    private creazionePraticaStoreService: CreazionePraticaStoreService,
    private router: Router
  ) {}


  ngOnDestroy(): void {
    this.componentDestroyed$.next();
  }

  ngOnInit() {
    this.suggested = [];
    this.options = [];
    this.entities = [];
    this.count = 0;
    if (this.modaleRicerca) this.modaleRicerca.inizializza(ServicePathsSettings.URL_SEARCH_PARTE, true);

    this.creazionePraticaStoreService.controparti$.pipe(takeUntil(this.componentDestroyed$)).subscribe(controparti => {
      this.controparti = [];
      if(controparti && controparti.length > 0){
        this.controparti = controparti;
      }
      this.checkParteisControparte();
    })

    const partiSuggestedStored$ = this.creazionePraticaStoreService.suggestedParti$.pipe(
      take(1),
      filter(suggested => suggested.length > 0),
      tap(suggested => this.suggested = suggested)
      );

    const entitiesAndTipiPersona$ = combineLatest(
      this.creazionePraticaStoreService.entities$.pipe(
        distinctUntilChanged(),
        filter(entities => entities.length > 0),
        tap(entities => {
          this.entities = filterElaborationEntityClean(entities, [ElaborationEntityConstants.PRINCIPAL_ACTOR]);
        })
      ),
      this.tipologicheService.getTipiPersona().pipe(
        distinctUntilChanged(),
        tap(tipoPersonaOptions => this.tipoPersonaOptions = tipoPersonaOptions)
      )
    ).pipe(take(1));

    concat(partiSuggestedStored$, entitiesAndTipiPersona$).pipe(
      takeUntil(this.componentDestroyed$),
      skipWhile(() => this.suggested.length > 0)
    ).subscribe(() => this.getSuggeriti());


  }

  private getSuggeriti() {
    if (this.entities && this.entities.length > 0 && this.tipoPersonaOptions && this.tipoPersonaOptions.length > 0) {

      if(this.router.url.endsWith('consultazione')){//logica per il nuovo wizard di consultazione
        let outputArray: ElaborationDocumentFilterEntity[] = [];

        this.entities.forEach(obj => {
            let cleanedValore = obj.valore.replace(/nome:|cognome:|ragioneSociale:/g, "").trim();
           let  formattedObj = Object.assign({}, obj);
           formattedObj.valore = cleanedValore;
           outputArray.push(formattedObj);
        });
        //outputArray = entities senza i prefissi nome e cognome
        //per ogni entita cerca simili su elastic search
        outputArray.forEach(element => this.operations.searchAnagrafiche(ServicePathsSettings.URL_SEARCH_PARTI_TUTTE, { searchText: element.valore.substring(0, element.valore.indexOf(" categoria")), fromResult: 0 }).subscribe(response => {
          let filteredResponse = response
          let anagraficheResponse: any[] = [];
          if(response.anagrafiche && response.anagrafiche !== null){
            response.anagrafiche.forEach(response => {
              if(response.nome && element.valore.includes(response.nome) &&
                  response.cognome && element.valore.includes(response.cognome)) {
                if (element.uri.includes('_') && response.codiceFiscale) {
                  if (element.uri.includes(response.codiceFiscale)) {
                    if (!isDuplicate(response, anagraficheResponse))
                      anagraficheResponse.push(response);
                  }
                } else {
                  if (!isDuplicate(response, anagraficheResponse))
                    anagraficheResponse.push(response);
                }
              } else if(response.ragioneSociale && element.valore.includes(response.ragioneSociale)) {
                if (element.uri.includes('_') && response.partitaIva) {
                  if (element.uri.includes(response.partitaIva)) {
                    if (!isDuplicate(response, anagraficheResponse))
                      anagraficheResponse.push(response);
                  }
                } else {
                  if (!isDuplicate(response, anagraficheResponse))
                    anagraficheResponse.push(response);
                }
              }
            })
          }
          filteredResponse.anagrafiche = anagraficheResponse;
          this.suggerimentiDaRicerca(filteredResponse, element);
          this.creazionePraticaStoreService.setSuggestedParti(this.suggested);
         })
        )

      } else {
      this.entities.forEach(element => {
        this.operations.searchAnagrafiche(ServicePathsSettings.URL_SEARCH_PARTI_TUTTE, { searchText: element.valore, fromResult: 0 }).subscribe(response => {
        this.suggerimentiDaRicerca(response, null);
        this.creazionePraticaStoreService.setSuggestedParti(this.suggested);
       });
      });
    }
      this.checkParteisControparte();
    }
  }

  public retrieveSearch(response: SearchAnagraficheResponse) {
    this.options = [];
    let listaFiltrata: T[] = [];
    if (response && <T[]>response.anagrafiche) {
      listaFiltrata = <T[]>response.anagrafiche;
      for (let element of listaFiltrata) {
        let isAssociable = isParteAssociable(element);
        this.options.push({isAssociable:isAssociable,isControparte:false, hasDetailsAnagrafica: false, anagrafica: element });
      }
    }
  }

  retrieveControparte(controparte: Controparte){
    controparte.parte = setTempId(controparte.parte);
    let contropartiFiltred = refreshContropartePrimaria(this.controparti,controparte);
    this.controparti.push(controparte);
    this.creazionePraticaStoreService.setControparti(contropartiFiltred);
    this.creazionePraticaStoreService.save();
    this.activeTab = 0;
  }

  salva(): void {
    console.log(JSON.stringify(this.controparti))
    this.creazionePraticaStoreService.setControparti(this.controparti);
    this.creazionePraticaStoreService.save();
    this.changeStep.emit();
  }


  reset(): void {
    this.count = 0;
    this.creazionePraticaStoreService.setControparti([]);
    this.creazionePraticaStoreService.save();
    // this.suggested = []
    // this.options = []
    // this.getSuggeriti();
  }

  private checkParteisControparte(){
    this.suggested.forEach(element => {
      isControparteAssociated(element , this.controparti)
    });
  }

  private suggerimentiDaRicerca(response: SearchAnagraficheResponse, entity) {
    let categoria;
    let  tipoSoggetto;
    this.count = this.count + 1;
    let listaFiltrata: any[] = [];
    if (response && response.anagrafiche) {
      listaFiltrata = response.anagrafiche;
      for (let element of listaFiltrata) {
        if(!element.rimosso){
            if(entity) {
              if (entity.valore.includes('categoria: ') && entity.valore.includes('tipoSoggetto: ')) {
                //recupera dal valore categoria e tipo
                categoria = entity.valore.substring(entity.valore.indexOf('categoria: ') + 'categoria: '.length, (entity.valore.indexOf(' tipoSoggetto: ')));
                tipoSoggetto = entity.valore.substring(entity.valore.indexOf('tipoSoggetto: ') + 'tipoSoggetto: '.length);
              } else {
                categoria = null;
                tipoSoggetto = null
              }

            }
            let isAssociable = isParteAssociable(element);
            this.suggested.push({ isAssociable: isAssociable, isControparte: false, hasDetailsAnagrafica: false, anagrafica: element, categoria: categoria !== '-' ? categoria : null, tipoSoggetto: tipoSoggetto != '-' ? tipoSoggetto : null});
        }
      }
    }
    if (this.count === this.entities.length) {
      let parti: Parte[] = [];
      this.suggested.forEach(element => {
        parti.push(element.anagrafica);
      });
      this.entities.forEach(entity => {
        const parteExtracted = extractParteEntityFromSearch(this.tipoPersonaOptions, entity, parti);
        if (parteExtracted) {
          if (entity) {
            if(entity.valore.includes('categoria: ') && entity.valore.includes('tipoSoggetto: ')) {
              categoria = entity.valore.substring(entity.valore.indexOf('categoria: ') + 'categoria: '.length, (entity.valore.indexOf(' tipoSoggetto: ')));
              tipoSoggetto = entity.valore.substring(entity.valore.indexOf('tipoSoggetto: ') + 'tipoSoggetto: '.length);
            } else {
              categoria = null;
              tipoSoggetto = null;
            }
          }
            let isAssociable = isParteAssociable(parteExtracted);
          this.suggested.push({ isAssociable: isAssociable, isControparte: false, hasDetailsAnagrafica: false, anagrafica: parteExtracted, categoria: categoria !== '-' ? categoria : null, tipoSoggetto: tipoSoggetto != '-' ? tipoSoggetto : null });
        }
      });
    }
    this.checkParteisControparte();
  }

  private suggerimentiDaRicercaPDA(response: SearchAnagraficheResponse) {
    this.count = this.count + 1
    let listaFiltrata: any[] = [];
    if (response && response.anagrafiche) {
      listaFiltrata = response.anagrafiche;
      console.log(listaFiltrata);
      for (let element of listaFiltrata) {
        if(!element.rimosso){
          //let isGiuridica = element.tipoPersona.label === this.PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA;
          //isGiuridica ? element.partitaIva = element.codiceFiscale : null;
          let isAssociable = isParteAssociable(element);
          //isGiuridica ? element.codiceFiscale  = null : null;
          this.suggested.push({ isAssociable: isAssociable, isControparte: false, hasDetailsAnagrafica: false, anagrafica: element });
        }
      }
    }

      let parti: Parte[] = [];
      this.suggested.forEach(element => {
        parti.push(element.anagrafica);
      });
      this.entities.forEach(entity => {
        const parteExtracted = extractParteEntityFromSearch(this.tipoPersonaOptions, entity, parti);
        if (parteExtracted) {
            let isAssociable = isParteAssociable(parteExtracted);
            this.suggested.push({ isAssociable: isAssociable, isControparte: false, hasDetailsAnagrafica: false, anagrafica: parteExtracted });
        }
      });
    this.checkParteisControparte();
  }



}
